import { MinzeElement } from 'minze'

export interface LvcClearInputIcon {}

export class LvcClearInputIcon extends MinzeElement {
  html = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#1E007D" fill-opacity="0.3"/>
      <g clip-path="url(#clip0_1861_20408)">
        <path d="M15.5 15.5C14.2223 14.4257 12.9921 13.2947 11.8132 12.1109M11.8132 12.1109C10.6677 10.9608 9.54474 9.74601 8.5 8.5M11.8132 12.1109C12.8965 10.8199 14.1812 9.74219 15.5 8.5M11.8132 12.1109C10.5682 13.4349 9.65598 14.211 8.5 15.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1861_20408">
          <rect width="10" height="10" fill="white" transform="translate(7 7)"/>
        </clipPath>
      </defs>
    </svg>
  `

  css = () => `
    
  `
}
